export default "<div>\r\n  Sidebar\r\n</div>\r\n"